const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Zeitfenster "letzte N Tage" aus einem einzigen Bezugszeitpunkt: `to` (exklusiv) ist
 * der Beginn des nächsten UTC-Tages, `from` genau N Tage davor. Das Fenster ist damit
 * nie länger als N Tage (API-Grenze 366) und enthält den heutigen Tag vollständig.
 */
export const citationWindow = (days: number, reference: Date = new Date()): { from: string; to: string } => {
  const endOfToday = Date.UTC(
    reference.getUTCFullYear(), reference.getUTCMonth(), reference.getUTCDate() + 1,
  );
  return { from: new Date(endOfToday - days * DAY_MS).toISOString(), to: new Date(endOfToday).toISOString() };
};
